import React from 'react';
import styles from './Badge.module.css';
import { joinClassNames } from '@utils/joinClassNames';

const Badge = ({ label, className = '' }) => {
  return label.trim() ? <span className={joinClassNames([styles.badge, className])}>{label.trim()}</span> : null;
};

export default Badge;
